<template>
  <div>
    <div v-for="index in resolution" :key="index">
      <span v-html="matchPlaceholders(metadata.titleTempl, placeholders[index])"></span>
      <div v-for="choice in placeholders[index].choices" :key="choice.CHOICE_TITLE">
        <span v-html="matchPlaceholders(metadata.statTempl, choice)"></span>
      </div>
      <span v-html="matchPlaceholders(metadata.decisionTempl, placeholders[index])"></span>
    </div>
  </div>
</template>

<script>
import { Bus } from "../main";

export default {
  name: "FormPRCT",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      metadata: this.field.metadata,
      resolution: [0, 1],
      placeholders: [
        {
          TITLE: "Resolution 1",
          choices: [
            {
              CHOICE_TITLE: "FOR",
              WEIGHTED_SHARE: 167994,
              WEIGHTED_PERC: 80.49,
            },
            {
              CHOICE_TITLE: "AGAINST",
              WEIGHTED_SHARE: 40725,
              WEIGHTED_PERC: 19.51,
            },
          ],
          DECLARE_STATEMENT: "I declare",
          DECISION: "PASSED",
        },
        {
          TITLE: "Resolution 2",
          choices: [
            {
              CHOICE_TITLE: "FOR",
              WEIGHTED_SHARE: 167994,
              WEIGHTED_PERC: 80.49,
            },
            {
              CHOICE_TITLE: "AGAINST",
              WEIGHTED_SHARE: 40725,
              WEIGHTED_PERC: 19.51,
            },
          ],
          DECLARE_STATEMENT: "I declare",
          DECISION: "PASSED",
        }
      ],
    };
  },
  methods: {
    matchPlaceholders: function (str, map) {
      let regex = new RegExp(/\${.+?}/g);
      let matches = str.match(regex);
      let output = str;
      if (matches) {
        matches.forEach(match => {
          const text = match.replace(/[${}]/g, "");
          output = output.replace(match, map[text]);
        })
      }

      // size attr in font tag is not using 'px', 'em' etc
      // match "size=20px>"
      regex = new RegExp(/size=.+?>/g);
      matches = str.match(regex);
      if (matches) {
        matches.forEach(match => {
          const size = match.replace(/size=|>/g, "");
          output = output.replace(match, `style="font-size: ${size};">`);
        })
      }
      return output;
    }
  },
  mounted() {
    Bus.$on("refreshPRCT", (field) => {
      if (this.field.layout.seq === field.layout.seq) {
        this.metadata = field.metadata;
      }
    })
  },
  beforeDestroy() {
    Bus.$off("refreshPRCT")
  },
};
</script>

<style scoped>
.pfsi-component {
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: center;
  column-gap: 1rem;
  row-gap: 1.5rem;
}

.side-label {
  display: flex;
  align-items: center;
}

.side-label > label {
  margin-right: 0.5rem;
}

.input-box {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  background: #fff;
  padding-left: 0.3rem;
  position: relative;
  overflow: visible;
}

.input-box > input {
  flex-grow: 1;
  font-size: 14px;
  background: #fff;
  border: none;
  outline: none;
  padding: 0.5rem;
  padding-left: 0;
  margin-top: 0.2rem;
  height: 1.5rem;
}

.input-label {
  position: absolute;
  transition: 0.2s;
  pointer-events: none;
  top: 0.65rem;
  font-size: 16px;
  white-space: nowrap;
  background: #fff;
}

.input-box > input:focus ~ .input-label,
.input-box > input:not(:placeholder-shown) ~ .input-label {
  top: -0.5rem;
  color: #0073c3;
  font-size: 13px;
  padding: 0 2px;
}

.input-box:focus-within {
  border: 2px solid #0073c3;
}

.underline {
  border: none;
  border-bottom: 1px solid #222;
  border-radius: 0;
}

.underline:focus-within {
  outline: none;
  border: none;
  border-bottom: 1px solid #000;
}

.grid-col-1-3 {
  grid-column: 1 / 3;
}

.grid-row-1-2 {
  grid-row: 1 / 2;
}

.grid-row-2-3 {
  grid-row: 2 / 3;
}

.required {
  color: #f00;
}
</style>